import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const EXPERIMENT_I18N_NAMESPACE =
  '@mc/next/experiments/prcng-1266_v1_cm_dual_cta'

export const i18nInstance = registerI18nResources({
  namespace: EXPERIMENT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
